export const DeleteIconSimple = ({ className = '', fill = '#05050D' }) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.88976 19V4.83333H2.94531V2.94444H7.66753V2H13.3342V2.94444H18.0564V4.83333H17.112V19H3.88976ZM5.77865 17.1111H15.2231V4.83333H5.77865V17.1111ZM7.66753 15.2222H9.55642V6.72222H7.66753V15.2222ZM11.4453 15.2222H13.3342V6.72222H11.4453V15.2222Z"
        fill={fill}
        fillOpacity="1"
        stroke="white"
        strokeWidth="0.2"
      />
    </svg>
  );
};
